export const downloadFile = async (response, fileName) => {
  const file = await response.blob();
  const downloadUrl = window.URL.createObjectURL(file);

  const tempAnchor = document.createElement('a');
  document.body.appendChild(tempAnchor);
  tempAnchor.download = fileName;
  tempAnchor.href = downloadUrl;
  tempAnchor.click();
  document.body.removeChild(tempAnchor); // cleanup
};

export const handleClickPhotoDownload = async (sessionId, errorCallback) => {
  const response = await fetch(
    `${process.env.REACT_APP_BASE_URL}/${sessionId}/image.jpg`,
    { mode: 'cors' },
  );
  if (response.ok) {
    await downloadFile(response, 'image.jpg');
  } else {
    errorCallback();
  }
};

export const handleClickTimelapseDownload = async (
  sessionId,
  errorCallback,
) => {
  const response = await fetch(
    `${process.env.REACT_APP_BASE_URL}/${sessionId}/timelapse.mp4`,
    { mode: 'cors' },
  );
  if (response.ok) {
    await downloadFile(response, 'timelapse.mp4');
  } else {
    errorCallback();
  }
};

export const handleClickVideoDownload = async (sessionId, errorCallback) => {
  const response = await fetch(
    `${process.env.REACT_APP_BASE_URL}/${sessionId}/video.mp4`,
    { mode: 'cors' },
  );
  if (response.ok) {
    await downloadFile(response, 'video.mp4');
  } else {
    errorCallback();
  }
};
